import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import DashboardLayout from './DashboardLayout';
import Overview from './pages/Overview';
import Appointments from './pages/Appointments';
import Communications from './pages/Communications';
import Customers from './pages/Customers';
import Analytics from './pages/Analytics';
import Integration from './pages/Integration';
import Settings from './pages/Settings';

const DashboardRoutes = () => {
  return (
    <DashboardLayout>
      <Routes>
        <Route index element={<Overview />} />
        <Route path="appointments" element={<Appointments />} />
        <Route path="communications" element={<Communications />} />
        <Route path="customers" element={<Customers />} />
        <Route path="analytics" element={<Analytics />} />
        <Route path="integration" element={<Integration />} />
        <Route path="settings" element={<Settings />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </DashboardLayout>
  );
};

export default DashboardRoutes;